import { useState } from "react";

export const useMakeApiCalls = (callBack = () => {}) => {
  const [apiLoading, setApiLoading] = useState(true);
  if (!apiLoading) return;
  callBack();
  setApiLoading(false);
};
